/* eslint-disable react-hooks/exhaustive-deps */
import { useState } from "react";
import CreateRecordButtonLayout from "../layout/CreateRecordButtonLayout";
import PopStockMoveCreateDialog from "../dialogTypes/PopStockMoveCreateDialog";

function PopStockMoveCreateButton ( props ) {
    const {id, schema, refresh, selectMstGrid, onSuccess, ...others} = props;
    const [open, setOpen] = useState(false);
    
    const onOpen = () => {
        setOpen(true);
    };

    const onClose = () => {
        setOpen(false);
    };

    const onCreateSuccess = (msg) => {
        if (onSuccess) {
            onSuccess (msg);
        }
        refresh.refresh ();
    };

    return (
        <>
            <CreateRecordButtonLayout id={id+"append-button"} onClick={onOpen} {...others} />
            <PopStockMoveCreateDialog
                id={id+"append-dialog"}
                schema={schema}
                open={open}
                onClose={onClose}
                onSuccess={onCreateSuccess}
            />
        </>
    );
}

export default PopStockMoveCreateButton;

